import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const ComplianceCategory = { id: 13, name: 'Compliance' };
export const inputGuardrailsPrompt = defineFeature({
    type: FeatureType.String,
    propName: 'input_guardrails_prompt',
    uiName: 'inputGuardrailsPrompt',
    displayName: 'Input Guardrails Prompt',
    description: 'Prompt identifier used to validate incoming user input before orchestration runs.',
    category: ComplianceCategory,
    areas: ['agent'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
    editor: 'prompt-select',
});
export const complianceFeatures = [inputGuardrailsPrompt];
